import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavBar from "./NavBar";
import Footer from "./Footer";
import BackToTop from "./BackToTop";

import '../Css/index.css'
import '../Css/responsive.css';

const WebLayout: React.FC = () => {
    const location = useLocation();

    const hideFooterPaths = location.pathname.startsWith('/auth');

    return (
        <React.Fragment>
            <header>
                <NavBar />
            </header>

            <main className="main_web_content">
                <Outlet />
            </main>

            {!hideFooterPaths && (<Footer />)}

            <BackToTop />
        </React.Fragment>
    )
}

export default WebLayout;